
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.heading{
  --sic-heading-color:var(--color-primary-default);
  break-after:avoid;
}

.table-wrapper{
  padding-top:var(--spacing-04);
}

@media print{

.table-wrapper{
    padding-top:var(--spacing-01)
}
  }

.full-table{
  padding-top:var(--spacing-04);
  padding-bottom:var(--spacing-08);
  padding-left:var(--spacing-04);
  padding-right:var(--spacing-08);
  overflow-x:auto;
}

@media print{

.full-table{
    overflow-x:visible;
    break-inside:avoid;
    font-size:2px !important;
    padding-top:var(--spacing-01);
    padding-bottom:var(--spacing-02);
    padding-left:var(--spacing-02);
    padding-right:var(--spacing-02)
}
  }

.caption{
  padding-top:var(--spacing-04);
  font-size:var(--body-01-font-size);
}

@media print{

.caption{
    font-size:calc(var(--body-01-font-size) * 0.5);
    padding-top:var(--spacing-01)
}
  }

@media print{

[cloned-slot-name='heading'] sic-heading *{
        font-size:calc(var(--headline-03-font-size) * 0.5) !important
    }
      }
`;